import { useMemo } from 'react';
import { useSaasSession } from './SessionContext';

const prefix = (value, fallback) => String(value || fallback).trim().replace(/[-\s]+$/, '') || fallback;
const enabled = (value, fallback = true) => typeof value === 'boolean' ? value : fallback;

export function createTenantNumbering(settings = {}) {
  return {
    Auto_Sales_Invoice: enabled(settings.autoSalesInvoice),
    Auto_Purchase_Invoice: enabled(settings.autoPurchaseInvoice),
    Auto_Customer_Code: enabled(settings.autoCustomerCode),
    Auto_Supplier_Code: enabled(settings.autoSupplierCode),
    Auto_Product_Code: enabled(settings.autoProductCode),
    Sales_Invoice_Prefix: prefix(settings.salesInvoicePrefix, 'INV'),
    Purchase_Invoice_Prefix: prefix(settings.purchaseInvoicePrefix, 'PUR'),
    Customer_Code_Prefix: prefix(settings.customerCodePrefix, 'CUS'),
    Supplier_Code_Prefix: prefix(settings.supplierCodePrefix, 'SUP'),
    Product_Code_Prefix: prefix(settings.productCodePrefix, 'P'),
  };
}

export function nextTenantNumber(prefixValue, count, width = 5) {
  return `${prefixValue}-${String(Number(count || 0) + 1).padStart(width, '0')}`;
}

export function useTenantNumbering() {
  const { tenant } = useSaasSession();
  return useMemo(() => createTenantNumbering(tenant?.settings || {}), [tenant?.settings]);
}
